import type { WorkshopStrings } from "./workshop.vi.ts";

/** English twin of `workshop.vi.ts`. */
export const workshopEn: WorkshopStrings = {
  rolls: (n) => `${n} ${n === 1 ? "roll" : "rolls"}`,
  hintCost: "Using a hint caps this level at 2 stars. Still want it?",
  stuck: "The rolls on the shelf can't cover the gaps left. Undo a few rolls and try again!",
  resultRolls: (n, best) =>
    n <= best ? `You wrapped it with ${n} rolls, as neat as the best solution!` : `You wrapped it with ${n} rolls, the neatest solution needs only ${best}.`,
  resultRule: (three, two) => `Three stars for ${three} rolls or fewer, two stars for ${two} or fewer.`,
  resultHint: "You used a hint, so 2 stars at most.",
  shelf: (n) => `${n} ${n === 1 ? "roll" : "rolls"} left`,
};
